import React from 'react';
import styled from 'styled-components';
import { Input } from 'antd';

export const FormInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`;

export const FormInputLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: silver;
  margin-bottom: 5px;
`;

export function FormInput({ label, ...inputProps }) {
  return (
    <FormInputWrapper>
      <FormInputLabel>{label}</FormInputLabel>
      <Input {...inputProps} />
    </FormInputWrapper>
  );
}
